import { render, staticRenderFns } from "./BrokenForm.vue?vue&type=template&id=c20076e4&"
import script from "./BrokenForm.vue?vue&type=script&lang=js&"
export * from "./BrokenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports